import { isClosedAssistantProjectStatus } from "@/store/assistant/assistant-project-status";
import { isClosedAssistantTaskStatus } from "@/store/assistant/assistant-task-status";

export const resolveAgentOverlayEntryMetrics = ({
  tasks,
  projects,
  taskCountLoaded,
  projectCountLoaded,
}: {
  tasks: ReadonlyArray<{ status: string }>;
  projects: ReadonlyArray<{ status: string }>;
  taskCountLoaded: boolean;
  projectCountLoaded: boolean;
}): { isLoaded: boolean; taskCount: number; projectCount: number } => ({
  isLoaded: taskCountLoaded && projectCountLoaded,
  taskCount: tasks.filter(task => !isClosedAssistantTaskStatus({ status: task.status })).length,
  projectCount: projects.filter(
    project => !isClosedAssistantProjectStatus({ status: project.status })
  ).length,
});
